import { connect } from 'react-redux';
import { changeCommissionStatus } from '../../../redux/commissions/actionCreators';
const mapDispatchToProps = {
    onClick: changeCommissionStatus
};
export default connect(null, mapDispatchToProps);
